export const DEFAULT_PROFILE_PHOTO =
  "https://www.shareicon.net/data/512x512/2016/07/26/802043_man_512x512.png";

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const saasToolName = [
  {
    label: "Okta",
    value: "Okta",
  },
  {
    label: "Box",
    value: "Box",
  },
  {
    label: "Jira",
    value: "Jira",
  },
  {
    label: "GitLab",
    value: "GitLab",
  },
  {
    label: "Confluence",
    value: "Confluence",
  },
  {
    label: "Atlassian",
    value: "Atlassian",
  },
  {
    label: "Youtrack",
    value: "Youtrack",
  },
  {
    label: "Slack",
    value: "Slack",
  },
  {
    label: "AnyDesk",
    value: "AnyDesk",
  },
  {
    label: "Miro",
    value: "Miro",
  },
  {
    label: "GCP",
    value: "GCP",
  },
  {
    label: "AWS",
    value: "AWS",
  },
  {
    label: "MergeBase",
    value: "MergeBase",
  },
  {
    label: "SOPHOS MDR",
    value: "SOPHOS_MDR",
  },
  {
    label: "SOPHOS MDR Server",
    value: "SOPHOS_MDR_Server",
  },
  {
    label: "SOPHOS ZTNA",
    value: "SOPHOS_ZTNA",
  },
  {
    label: "SOPHOS Cloud Optix",
    value: "SOPHOS_Cloud_Optix",
  },
];

export const saasToolNameForPayment = [
  {
    label: "Okta",
    value: "Okta",
  },
  {
    label: "Box",
    value: "Box",
  },
  {
    label: "Jira",
    value: "Jira",
  },
  {
    label: "GitLab",
    value: "GitLab",
  },
  {
    label: "Confluence",
    value: "Confluence",
  },
  {
    label: "Atlassian",
    value: "Atlassian",
  },
  {
    label: "Youtrack",
    value: "Youtrack",
  },
  {
    label: "Slack",
    value: "Slack",
  },
  {
    label: "AnyDesk",
    value: "AnyDesk",
  },
  {
    label: "Miro",
    value: "Miro",
  },
  {
    label: "GCP",
    value: "GCP",
  },
  {
    label: "AWS",
    value: "AWS",
  },
  {
    label: "MergeBase",
    value: "MergeBase",
  },
  {
    label: "SOPHOS MDR",
    value: "SOPHOS MDR",
  },
  {
    label: "SOPHOS MDR Server",
    value: "SOPHOS MDR Server",
  },
  {
    label: "SOPHOS ZTNA",
    value: "SOPHOS ZTNA",
  },
  {
    label: "SOPHOS Cloud Optix",
    value: "SOPHOS Cloud Optix",
  },
  {
    label: "Namecheap",
    value: "Namecheap",
  },
];

export const CURRENCY = [
  {
    label: "JPY",
    value: "JPY",
  },
  {
    label: "USD",
    value: "USD",
  },
];

export const SubscriptionsName = [
  {
    label: "Free",
    value: "Free",
  },
  {
    label: "Premium",
    value: "Premium",
  },
  {
    label: "Business",
    value: "Business",
  },
  {
    label: "Cloud",
    value: "Cloud",
  },
  {
    label: "Cloud Optix",
    value: "Cloud Optix",
  },
  {
    label: "Enterprise",
    value: "Enterprise",
  },
  {
    label: "Enterprise Plus",
    value: "Enterprise Plus",
  },
  {
    label: "Enterprise Cloud",
    value: "Enterprise Cloud",
  },
  {
    label: "Enterprise Trial",
    value: "Enterprise Trial",
  },
  {
    label: "ZTNA",
    value: "ZTNA",
  },
  {
    label: "MDR",
    value: "MDR",
  },
  {
    label: "MDR Server",
    value: "MDR Server",
  },
  {
    label: "As Pay As You Go",
    value: "As Pay As You Go",
  },
  {
    label: "SSO, Adaptive MFA, Universal Directory, Lifecycle Management",
    value: "SSO, Adaptive MFA, Universal Directory, Lifecycle Management",
  },
  // {
  //   label: "Adaptive MFA",
  //   value: "Adaptive MFA",
  // },
  // {
  //   label: "Universal Directory",
  //   value: "Universal Directory",
  // },
  // {
  //   label: "Lifecycle Management",
  //   value: "Lifecycle Management",
  // },
];

export const PAYMENT_TYPE_ARRAY = [
  "New",
  "Renewal",
  "Additional",
  "Monthly",
  "On Demand",
];

export const PAYMENT_TYPE_OPTIONS = [
  {
    label: "New",
    value: "New",
  },
  {
    label: "Renewal",
    value: "Renewal",
  },
  {
    label: "Additional",
    value: "Additional",
  },
  {
    label: "Monthly",
    value: "Monthly",
  },
  {
    label: "On Demand",
    value: "On Demand",
  },
];

export const PricingStructure = [
  {
    label: "Monthly",
    value: "Monthly",
  },
  {
    label: "Yearly",
    value: "Yearly",
  },
];
//organizations pricing list tool name. Used in table cellData
export const SAAS_TOOLS = [
  "okta",
  "box",
  "gitlab",
  "confluence",
  "atlassian",
  "youtrack",
  "miro",
  "gcp",
  "shophos_mdr",
  "shophos_mdr_server",
  "shophos_ztna",
  "shophos_cloud_optix",
];

export const All_SAAS_TOOLS = [
  "UR&AM Tool",
  "Okta",
  "Box",
  "GitLab",
  "Confluence",
  "Youtrack",
  "Miro",
  "MergeBase",
  "GCP",
  "AWS",
  "SOPHOS MDR",
  "SOPHOS MDR Server",
  "SOPHOS ZTNA",
  "SOPHOS Cloud Optix",
];

export const REQUEST_MANAGEMENT_SAAS_TOOLS = [
  {
    label: "Confluence",
    value: "Confluence",
  },
  {
    label: "GitLab",
    value: "GitLab",
  },
  {
    label: "MergeBase",
    value: "MergeBase",
  },
  {
    label: "Miro",
    value: "Miro",
  },
  {
    label: "Youtrack",
    value: "Youtrack",
  },
  {
    label: "Box",
    value: "Box",
  },
  {
    label: "GCP",
    value: "GCP",
  },
  {
    label: "AWS",
    value: "AWS",
  },
  {
    label: "Sleet",
    value: "Sleet",
  },
  {
    label: "SOPHOS MDR Agent Installation",
    value: "SOPHOS MDR Agent Installation",
  },
  {
    label: "SOPHOS MDR Server Agent Installation",
    value: "SOPHOS MDR Server Agent Installation",
  },
  {
    label: "SOPHOS Cloud Optix",
    value: "SOPHOS Cloud Optix",
  },
  {
    label: "SOPHOS MDR",
    value: "SOPHOS MDR",
  },
];

export const INTERNAL_EMAIL_DOMAINS = [
  "onemitutoyodevops.com",
  "bjitgroup.com",
  "mitutoyo.co.jp",
  "mitutoyo-rda.com",
  "MITUTOYO-CTL.DE",
  "mitutoyo.com",
  "mitutoyo-ct.de",
];

export const REQUEST_MANAGEMENT_TYPE_OPTIONS = [
  { label: "Group", value: "Group" },
  { label: "Project", value: "Project" },
  { label: "Space", value: "Space" },
  { label: "Team", value: "Team" },
  { label: "Dashboard", value: "Dashboard" },
  { label: "License", value: "License" },
  { label: "OS", value: "OS" },
];

export const YOU_TRACK_URL = "https://onemitutoyodevops.youtrack.cloud/issue/";
export const SOMETHING_WENT_WRONG =
  "Something went wrong. Please try again later.";
export const NOTE_FOR_LICENSE_MANAGEMENT =
  "Unit Price is calculated by dividing the total annual payment by the total number of licenses and then dividing by 12 to get the monthly cost of a license for a SaaS tool.";

export const ROUTE = {
  LICENSE_MANAGEMENT: "/licensing-summary",
  LICENSE_HISTORY_LIST: "/licensing-summary/licensing-history",
  LICENSE_REQUISITION: "/licensing-summary/requisition",
  ADD_SAAS_TOOL: "/licensing-summary/add-saas-tool",
  EDIT_SAAS_TOOL: "/licensing-summary/edit-saas-tool",
  OKTA_USER_LIST: "/okta-user-list",
  OKTA_INVITED_USER_LIST: "/okta-invited-user-list",
  OKTA_APP_LIST: "/okta-app-list",
  OKTA_GROUP_LIST: "/okta-group-list",
  OKTA_DEVICE_LIST: "/okta-device-list",
  USER_REGISTRATION: "/ur&am-tool-user-registration",
  USER_LIST: "/user-list",
  USER_EDIT: "/user-edit",
  USER_PROFILE: "/user-profile",
  BOX_USER_LIST: "/box-user-list",
  BOX_COLLABORATOR_LIST: "/box-collaborator-list",
  BOX_COLLABORATOR_HISTORY: "/box-collaborator-history",
  BOX_INVITED_USER_LIST: "/box-invited-user-list",
  GITLAB_USER_LIST: "/gitlab-user-list",
  GITLAB_GROUP_LIST: "/gitlab-group-list",
  GITLAB_GROUP_STORAGE_COMPARISON: "/gitlab-group-storage-comparison",
  GITLAB_PROJECT_LIST: "/gitlab-project-list",
  GITLAB_INVITED_USER_LIST: "/gitlab-invited-user-list",
  YOUTRACK_USER_LIST: "/youtrack-user-list",
  YOUTRACK_INVITED_USER_LIST: "/youtrack-invited-user-list",
  YOUTRACK_GROUP_LIST: "/youtrack-group-list",
  YOUTRACK_PROJECT_LIST: "/youtrack-project-list",
  SUPPORT_TICKET_STATUS: "/support-tickets-status",
  SUPPORT_TICKETS_LIST: "/support-tickets-list",
  API_KEY: "/api-key-management",
  CONFLUENCE_USER_LIST: "/confluence-user-list",
  CONFLUENCE_INVITED_USER_LIST: "/confluence-invited-user-list",
  CONFLUENCE_GROUP_LIST: "/confluence-group-list",
  CONFLUENCE_SPACE_LIST: "/confluence-space-list",
  ATLASSIAN_USER_LIST: "/atlassian-user-list",
  ATLASSIAN_INVITED_USER_LIST: "/atlassian-invited-user-list",
  MIRO_USER_LIST: "/miro-user-list",
  MIRO_INVITED_USER_LIST: "/miro-invited-user-list",
  MIRO_TEAM_LIST: "/miro-team-list",
  MIRO_PROJECT_LIST: "/miro-project-list",
  MIRO_BOARD_LIST: "/miro-board-list",
  BROADCAST_EMAIL: "/create-broadcast-email",
  BROADCAST_HISTORY: "/email-broadcast-history",
  ACTIVITY_REPORT: "/user-activity-report",
  UNRESPONSIVE_USERS: "/unresponsive-users",
  ORGANIZATION_LIST: "/organization-list",
  ORGANIZATION_CREATE: "/create-organization",
  ORGANIZATION_EDIT: "/organization-edit",
  MITUTOYO_PROJECT_LIST: "/mitutoyo-project-list",
  MITUTOYO_DEPARTMENT_LIST: "/mitutoyo-department-list",
  MITUTOYO_SECTION_LIST: "/mitutoyo-section-list",
  SAAS_TOOl_WISE_BUDGET: "/saas-tool-wise-cost",
  CLOUD_BUDGET: "/cloud-budget",
  EDIT_CLOUD_BUDGET: "/edit-cloud-budget",
  ADD_BUDGET: "/add-budget",
  COST_HISTORY: "/cost-history",
  ORGANIZATIONS_WISE_BUDGET: "/organizations-wise-budget",
  USER_WISE_BUDGET: "/user-wise-budget",
  GCP_USER_LIST: "/gcp-user-list",
  GCP_INVITED_USER_LIST: "/gcp-invited-user-list",
  GCP_GROUP_LIST: "/gcp-group-list",
  GCP_PROJECT_BILLING_INFO: "/gcp-project-billing-info",
  AWS_USER_LIST: "/aws-user-list",
  AWS_INVITED_USER_LIST: "/aws-invited-user-list",
  AWS_GROUP_LIST: "/aws-group-list",
  AWS_BILLING: "/aws-billing",
  SOPHOS_USER_LIST: "/sophos-user-list",
  SOPHOS_INVITED_USER_LIST: "/sophos-invited-user-list",
  SOPHOS_GROUP_LIST: "/sophos-group-list",
  KLOCWORK: "/klocwork",
  RENOREX: "/renorex",
  ASTAH: "/astah",
  INSTALLSHIELD: "/installshield",
  INVENTORY_MANAGEMENT: "/inventory-management",
  STATIC_REPORTING: "/static-report",
  DYNAMIC_REPORTING: "/dynamic-report",
  UM_TOOL_USER_ROLE_LIST: "/ur&am-tool-user-role-list",
  ROLE_CREATE: "/add-role",
  ROLE_EDIT: "/edit-role",
  OTP_VERIFICATION: "/otp-verification",
  SAML: "/saml",
  PRIVACY_POLICY: "/privacy-policy",
  LOGIN: "/login",
  LOGOUT: "/logout",
  PAYMENT_HISTORY: "/payment-history",
  PAYMENT_REPORT: "/payment-report",
  PAYMENT_CREATE: "/create-payment",
  PAYMENT_EDIT: "/edit-payment",
  APPROVER_LIST: "/approver-list",
  ADD: "/add",
  EDIT: "/edit",
  REQUEST_LIST: "/request-list",
  COMMENTS: "/comments",
  MERGEBASE_USER_LIST: "/mergebase-user-list",
  MERGEBASE_DASHBOARD_LIST: "/mergebase-dashboard-list",
  REQUEST_HISTORY: "/request-history",
  REQUEST_WATCH_LIST: "/request-watch-list",
  CREATE_REQUEST: "/create-request",
  PENDING_REQUEST_LIST: "/pending-request-list",
  MY_APPROVED_LIST: "/reviewed-list",
  ALL_REQUEST_LIST: "/all-request-list",
  APPROVED_REQUEST_LIST: "/approved-request-list",
  UM_TOOL_USER_LIST: "/ur&am-tool-user-list",
  NOTIFICATION_ALERTS: "/notification-and-alerts",
  CREDENTIALS_LIST: "/credentials-list",
  CREDENTIALS_CREATE: "/create-credentials",
  MY_CREDENTIAL: "/my-credential",
  SLEET_PROJECT_LIST: "/sleet-project-list",
};
export const DESIGNATION = {
  SECTION_HEAD: "Section Head",
  SECTION_MANAGER: "Section Manager",
  MANAGER: "Manager",
  ARCHITECT: "Architect",
  DEVELOPER: "Developer",
  ADMINISTRATOR: "Administrator",
  UNKNOWN: "Unknown",
  SOFTWARE_ENGINEER: "Software Engineer",
  TEST_ENGINEER: "Test Engineer",
  SCRUM_MASTER: "Scrum Master",
  DIRECTOR: "Director",
  SOFTWARE_TEST_ENGINEER: "Software Test Engineer",
  BUILD_RELEASE_ENGINEER: "Build & Release Engineer",
  EXECUTIVE_VICE_PRESIDENT: "Executive Vice President",
  SYSTEM_TEST_ENGINEER: "System Test Engineer",
  FIRMWARE_ENGINEER: "Firmware Engineer",
  TECHNICAL_WRITER: "Technical Writer",
  PRODUCT_VISION_DIRECTOR: "Product Vison Director",
  SOFTWARE_DEVELOPMENT_MANAGER: "Software Development Manager",
  ALGORITHM_SCIENTIST: "Algorithm Scientist",
  SYSTEMS_ENGINEER: "Systems Engineer",
  UX_UI_DESIGNER: "UX/UI DESIGNER",
  PRESIDENT: "PRESIDENT",
  LOCALIZATION_SPECIALIST: "Localization Specialist",
  R_AND_D_ALGORITHM_RESEARCH_MANAGER: "R&D AND ALGORITHM RESEARCH MANAGER",
  SYSTEM_ANALYST: "System Analyst",
};

export const DESIGNATION_OPTIONS = Object.values(DESIGNATION).map((item) => ({
  label: item,
  value: item,
}));
// export const DEPARTMENT = {
//   SDD_SECTION_1: "SDD Section 1",
//   SDD_SECTION_2: "SDD Section 2",
//   SDD_SECTION_3: "SDD Section 3",
//   SDD_SECTION_4: "SDD Section 4",
//   SDD_SECTION_5: "SDD Section 5",
//   SDD_SECTION_6: "SDD Section 6",
//   SDG: "SDG",
//   ARTD: "ARTD",
//   CTLG: "CTLG",
//   UNKNOWN: "Unknown",
// };

export const DEPARTMENTS = {
  SDD: "SDD",
  SDG: "SDG",
  DEVOPS: "DevOps",
  KPD: "KPD",
  MC_PLANT: "MC Plant",
  PRODUCT_DESIGN: "Product Design",
  UNKNOWN: "Unknown",
  ARTD: "ARTD",
  CTLG: "CTLG",
  MDD: "MDD",
  IDO: "IDO",
  EFDD: "EFDD",
  KURE_PRODUCT_DEVELOPMENT_DEPARTMENT: "Kure Product Development Department",
  KURE_QUALITY_CONTROL: "Kure Quality Control",
  KURE_MEASUREMENT_SOLUTION_OFFICE: "Kure Measurement Solution Office",
  GLOBAL_MARKETING_DIVISION: "Global Marketing Division",
  MRD: "MRD",
  CTLA: "CTLA",
  MRD_MC_PDD: "MRD MC-PDD",
  CTLAB_AMERICA: "CTLab America",
};

export const DEPARTMENT_OPTIONS = Object.values(DEPARTMENTS).map((item) => ({
  label: item,
  value: item,
}));

export const ORG_ADDRESS = {
  MIZONOKUCHI: "Mizonokuchi(Kawasaki), Japan",
  SAPPORO: "Sapporo(Hokkaido), Japan",
  KURE: "Kure(Hiroshima), Japan",
  MIYAZAKI: "Miyazaki(Miyazaki), Japan",
  TOKYO: "Tokyo, Japan",
  UTSUNOMIYA: "Utsunomiya(Tochigi), Japan",
  WASHINGTON: "Washington, USA",
  CALIFORNIA: "California, USA",
  ILLINOIS: "Illinois, USA",
  // BAYERN: "Bayern, Germany",
  VOELKLINGEN: "Voelklingen, Germany",
  BADEN_WUERTTEMBERG: "Baden-Wuerttemberg, Germany",
  HAMBURG: "Hamburg, Germany",
  DHAKA: "Dhaka, Bangladesh",
  HANOI: "Hanoi, Vietnam",
  DANANG: "DaNang, Vietnam",
  SOFIA: "Sofia, Bulgaria",
  TORONTO: "Toronto, Canada",
  ROTSELAAR: "Rotselaar, Belgium",
  UNKNOWN: "Unknown",
};

export const ORG_ADDRESS_OPTIONS = Object.values(ORG_ADDRESS).map((item) => ({
  label: item,
  value: item,
}));

export const PAGE_NAME = {
  DASHBOARD: "Dashboard",
  USER_REGISTRATION: "UR&AM Tool User Registration",
  USER_LIST: "User List",
  USER_DETAILS: "User Details",
  USER_UPDATE: "Update User",
  USER_PROFILE: "Profile",
  BOX_INVITED_USER_LIST: "Box Invited User List",
  BOX_USER_LIST: "Box User List",
  BOX_COLLABORATOR_LIST: "Box Collaborator List",
  BOX_COLLABORATOR_HISTORY: "Box Collaborator History",
  BOX_COLLABORATOR_DETAILS: "Box Collaborator Details",
  BOX_USER_INFO: "Box User's Info",
  BROADCAST_EMAIL: "Create Broadcast Email",
  BROADCAST_HISTORY: "Email Broadcast History",
  BROADCAST_INFO: "Broadcast Info",
  CONFLUENCE_SPACE_LIST: "Confluence Space List",
  CONFLUENCE_GROUP_LIST: "Confluence Group List",
  CONFLUENCE_GROUP_INFO: "Confluence Group Info",
  CONFLUENCE_INVITED_USER_LIST: "Confluence Invited User List",
  CONFLUENCE_USER_LIST: "Confluence User List",
  CONFLUENCE_USER_INFO: "Confluence User Info",
  ATLASSIAN_INVITED_USER_LIST: "Atlassian Invited User List",
  ATLASSIAN_USER_LIST: "Atlassian User List",
  ATLASSIAN_USER_INFO: "Atlassian User Info",
  GCP_GROUP_LIST: "GCP Group List",
  GCP_GROUP_INFO: "GCP Group Info",
  GCP_INVITED_USER_LIST: "GCP Invited User List",
  GCP_USER_LIST: "GCP User List",
  GCP_USER_INFO: "GCP User Info",
  GCP_PROJECT_BILLING_INFO: "GCP Project Billing Info",
  GITLAB_GROUP_LIST: "GitLab Group List",
  GITLAB_GROUP_INFO: "GitLab Group Info",
  GITLAB_GROUP_STORAGE_COMPARISON: "GitLab Group Storage Comparison",
  GITLAB_INVITED_USER_LIST: "GitLab Invited User List",
  GITLAB_PROJECT_LIST: "GitLab Project List",
  GITLAB_USER_LIST: "GitLab User List",
  LICENSE_MANAGEMENT: "Licensing Summary",
  LICENSE_REQUISITION: "License Requisition",
  LICENSE_SUMMARY_DETAILS: "Licensing Details",
  ADD_SAAS_TOOL: "Add SaaS Tool",
  EDIT_SAAS_TOOL: "Edit SaaS Tool",
  LICENSE_HISTORY_LIST: "Licensing History",
  LICENSE_HISTORY_DETAILS: "Licensing History Details",
  LICENSE_HISTORY: "Licensing History",
  MIRO_TEAM_LIST: "Miro Team List",
  MIRO_TEAM_INFO: "Miro Team Info",
  MIRO_PROJECT_LIST: "Miro Project List",
  MIRO_PROJECT_INFO: "Miro Project Info",
  MIRO_BOARD_INFO: "Miro Board Info",
  MIRO_BOARD_LIST: "Miro Board List",
  MIRO_INVITED_USER_LIST: "Miro Invited User List",
  MIRO_USER_LIST: "Miro User List",
  MIRO_USER_INFO: "Miro User Info",
  OKTA_APP_LIST: "Okta App List",
  OKTA_APP_INFO: "Okta App Info",
  OKTA_GROUP_LIST: "Okta Group List",
  OKTA_DEVICE_LIST: "Okta Device List",
  OKTA_DEVICE_INFO: "Okta Device Info",
  OKTA_GROUP_INFO: "Okta Group Info",
  OKTA_INVITED_USER_LIST: "Okta Invited User List",
  OKTA_USER_LIST: "Okta User List",
  OKTA_USER_INFO: "Okta User Info",
  ORGANIZATION_LIST: "Organization List",
  MITUTOYO_PROJECT_LIST: "Mitutoyo Project List",
  MITUTOYO_DEPARTMENT_LIST: "Mitutoyo Department List",
  MITUTOYO_SECTION_LIST: "Mitutoyo Section List",
  ORGANIZATION: "Organization",
  CREATE: "Create",
  EDIT: "Edit",
  ORGANIZATION_INFO: "Organization Info",
  MITUTOYO_PROJECT_INFO: "Mitutoyo Project Info",
  MITUTOYO_DEPARTMENT_INFO: "Mitutoyo Department Info",
  MITUTOYO_SECTION_INFO: "Mitutoyo Section Info",
  SAAS_TOOl_WISE_BUDGET: "SaaS Tool Wise Cost (Monthly)",
  COST_HISTORY: "Cost History",
  ORGANIZATIONS_WISE_BUDGET: "Organizations Wise Budget (Monthly)",
  USER_WISE_BUDGET: "User Wise Budget (Monthly)",
  ACTIVITY_REPORT: "User Activity Report",
  UNRESPONSIVE_USERS: "Unresponsive Users",
  YOUTRACK_GROUP_LIST: "YouTrack Group List",
  YOUTRACK_PROJECT_LIST: "YouTrack Project List",
  YOUTRACK_PROJECT_INFO: "YouTrack Project Info",
  SUPPORT_TICKETS_LIST: "Support Tickets List",
  SUPPORT_TICKET_STATUS: "Support Tickets Status",
  SUPPORT_TICKET_INFO: "Support Ticket Info",
  YOUTRACK_INVITED_USER_LIST: "Youtrack Invited User List",
  YOUTRACK_USER_LIST: "YouTrack User List",
  YOUTRACK_USER_INFO: "YouTrack User Info",
  AWS_USER_LIST: "AWS User List",
  AWS_USER_INFO: "AWS User Info",
  AWS_INVITED_USER_LIST: "AWS Invited User List",
  AWS_GROUP_LIST: "AWS Group List",
  AWS_GROUP_INFO: "AWS Group Info",
  AWS_BILLING: "AWS Billing Info",
  SOPHOS_USER_LIST: "Sophos User List",
  SOPHOS_USER_INFO: "Sophos User Info",
  SOPHOS_INVITED_USER_LIST: "Sophos Invited User List",
  SOPHOS_GROUP_LIST: "Sophos Group List",
  SOPHOS_GROUP_INFO: "Sophos Group Info",
  FLOATING_LICENSE: "Floating License",
  INVENTORY_MANAGEMENT: "Inventory Management",
  STATIC_REPORTING: "Static Report",
  DYNAMIC_REPORTING: "Dynamic Report",
  UM_TOOL_USER_ROLE_LIST: "UR&AM Tool User Role List",
  UM_TOOL_USER_ROLE_DETAILS: "UR&AM Tool User Role Details",
  ROLE_CREATE: "UR&AM Tool User Role Create",
  ROLE_EDIT: "UR&AM Tool User Role Edit",
  PAYMENT_HISTORY: "Payment History",
  PAYMENT_DETAILS: "Payment Details",
  PAYMENT_CREATE: "Create Payment",
  PAYMENT_EDIT: "Edit Payment",
  PAYMENT_REPORT: "Payment Report",
  APPROVER_LIST: "Approver List",
  APPROVER_ADD: "Add Approver",
  APPROVER_EDIT: "Edit Approver",
  REQUEST_LIST: "Request List",
  REQUEST_DETAILS: "Request Details",
  COMMENTS: "Comments",
  REQUEST_CREATE: "Create Request",
  UM_TOOL_USER_LIST: "UR&AM Tool User List",
  UM_TOOL_USER_DETAILS: "UR&AM Tool User Details",
  APPROVED_REQUEST_LIST: "Approved Request List",
  APPROVED_REQUEST_DETAILS: "Approved Request Details",
  PENDING_REQUEST_LIST: "Pending Request List",
  MY_APPROVED_LIST: "Reviewed List",
  REQUEST_HISTORY: "Request History",
  REQUEST_WATCH_LIST: "Request Watch List",
  ALL_REQUEST_LIST: "All Request List",
  CREDENTIAL_LIST: "Credentials List",
  SLEET_PROJECT_LIST: "Sleet Project List",
  CREATE_SLEET_PROJECT: "Create Sleet Project",
  EDIT_SLEET_PROJECT: "Edit Sleet Project",
  CREATE_CREDENTIAL: "Create Credentials",
  MY_CREDENTIAL: "My Credentials",
  MEMBERS: "Members",
  MERGEBASE_USER_LIST: "MergeBase User List",
  MERGEBASE_USER_INFO: "MergeBase User Info",
  MERGEBASE_DASHBOARD_LIST: "MergeBase Dashboard List",
  MERGEBASE_DASHBOARD_INFO: "MergeBase Dashboard Info",
  CLOUD_BUDGET: "Cloud Budget",
  CLOUD_BUDGET_INFO: "Cloud Budget Info",
  ADD_CLOUD_BUDGET: "Add Cloud Budget",
  EDIT_CLOUD_BUDGET: "Edit Cloud Budget",
};

export const API_URL = {
  CREATE: "/create",
  UPDATE: "/update",
  USERS: "/users",
  API_KEY: "/api-key",
  ROLES: "/roles",
  PERMISSIONS: "/permissions",
  CATEGORY_WISE_PERMISSIONS: "/category-wise-permissions",
  LOGIN: "/login",
  SAML_LOGIN: "/saml/login",
  REGISTER: "/register",
  LOGOUT: "/logout",
  BROADCAST: "/broadcast",
  LICENSE: "/license",
  LICENSE_HISTORY_LIST: "/history-list",
  REPORT: "/report",
  OKTA_USERS: "/okta/users",
  OKTA_APPS: "/okta/apps",
  OKTA_GROUPS: "/okta/groups",
  OKTA_DEVICES: "/okta/devices",
  ORGANIZATIONS: "/organizations",
  PRICING: "/pricing",
  REPORTS_ACTIVITY: "/reports/activity",
  UNRESPONSIVE_USER: "/reports/unresponsive-users",
  REPORTS_ACTIVITY_DAYS: "/reports/users-last-activity-date",
  SAAS_TOOLS: "/saas-tools",
  SYNC_USER: "/sync-user",
  INVITED_USER_LIST: "/invited-user-list",
  USER_PROJECTS: "/user-projects",
  USER_TEAMS: "/user-teams",
  USER_BOARDS: "/user-boards",
  GROUPS: "/groups",
  USER_GROUPS: "/user-groups",
  GROUP_USERS: "/group-users",
  USER_SYNC_BY_CSV: "/user-sync-by-csv",
  GROUP_LIST: "/group-list",
  GITLAB: "/gitlab",
  STORAGE_COMPARISON: "/storage-comparison",
  PROJECTS: "/projects",
  PROJECT: "/project",
  PIPELINE_REPORTS: "/pipeline-reports",
  PROJECT_LIST: "/project-list",
  PROJECT_MEMBER: "/project-member",
  TEAMS: "/teams",
  TEAM_MEMBERS: "/team-members",
  BOARDS: "/boards",
  BOARD_MEMBERS: "/board-members",
  YOUTRACK_TICKETS: "/youtrack/tickets",
  YOUTRACK_TICKET_REPORTS: "/youtrack/ticket-reports",
  YOUTRACK_TICKET_SPENT_TIME_REPORTS: "/youtrack/ticket-spent-time-reports",
  YOUTRACK_SYNC_TICKETS: "/youtrack/sync-tickets",
  GCP_PROJECT_BILLING_INFO: "reports/project-billing",
  AWS_BILLING_INFO: "reports/aws-billing",
  AWS_BILLING_REPORT: "reports/aws-billing-report",
  MIRO_BOARD_REPORT_BY_PROJECT: "reports/miro-board-report-by-project",
  UPDATE_PROFILE: "/update-profile",
  OTP: "otp",
  RESEND_OTP: "resend-otp",
  PAYMENT: "/payment",
  APPROVER: "/approver",
  SAAS_TOOL_ITEM_MEMBER: "/saas-tool-item-member",
  ME: "/me",
  DASHBOARD: "/dashboard",
  DATA: "/data",
  GROUP_DATA: "/group-data",
  NOTIFICATION: "/notification",
  REQUEST_MANAGEMENT: "/request-management",
  CHILD_REQUEST: "/child-request",
  PENDING: "/pending",
  MY_APPROVED_LIST: "/my-approved-list",
  ENTITY_LIST: "/entity-list",
  MIRO: "/miro",
  BOARD_REPORTS: "/board-reports",
  TEAM: "/team",
  REVIEW: "/review",
  APPROVED: "/approved",
  CHANGE_STATUS: "/change-status",
  MY_REQUESTS: "/my-requests",
  WATCH_LIST: "/watch-list",
  ADD_COMMENT: "/add-comment",
  CLOSE_REQUEST: "/close-request",
  CANCEL_REQUEST: "/cancel-request",
  WATCHERS: "/watchers",
  COST: "/cost",
  CLOUD_BUDGET: "/cloud-budget",
  SLEET: "/sleet",
  CREDENTIALS: "/credentials",
  CHANGE_CREDENTIAL: "/change-credential",
  FORGOT_CREDENTIAL: "/forgot-credential",
  RESET_CREDENTIAL: "/reset-credential",
  BOX_COLLABORATORS: "/box/collaborators",
  BOX_COLLABORATIONS: "/box/collaborations",
  MEMBERS: "/members",
  DEPARTMENTS: "/departments",
  SECTIONS: "/sections",
  ASSIGN_ASSIGNEE: "/assign-assignee",
};

export const PERMISSIONS = {
  API_KEY_VIEW: {
    title: "api-key-view",
    displayTitle: "API Key View",
    category: "API Key",
  },
  API_KEY_CREATE: {
    title: "api-key-create",
    displayTitle: "API Key Create",
    category: "API Key",
  },
  API_KEY_DELETE: {
    title: "api-key-delete",
    displayTitle: "API Key Delete",
    category: "API Key",
  },
  API_KEY_EDIT: {
    title: "api-key-edit",
    displayTitle: "API Key Edit",
    category: "API Key",
  },
  DASHBOARD_VIEW: {
    title: "dashboard-view",
    displayTitle: "Dashboard View",
    category: "Dashboard",
  },
  BROADCAST_VIEW: {
    title: "broadcast-view",
    displayTitle: "Broadcast View",
    category: "Broadcast",
  },
  BROADCAST_EMAIL_CREATE: {
    title: "broadcast-email-create",
    displayTitle: "Broadcast Email Create",
    category: "Broadcast",
  },
  REPORTING_VIEW: {
    title: "reporting-view",
    displayTitle: "Reporting View",
    category: "Reporting",
  },
  STATIC_REPORT_VIEW: {
    title: "static-report-view",
    displayTitle: "Static Report View",
    category: "Reporting",
  },
  ACTIVITY_REPORT_VIEW: {
    title: "activity-report-view",
    displayTitle: "Activity Report View",
    category: "Reporting",
  },
  DYNAMIC_REPORT_VIEW: {
    title: "dynamic-report-view",
    displayTitle: "Dynamic Report View",
    category: "Reporting",
  },
  DYNAMIC_REPORT_CREATE: {
    title: "dynamic-report-create",
    displayTitle: "Dynamic Report Create",
    category: "Reporting",
  },
  DYNAMIC_REPORT_EDIT: {
    title: "dynamic-report-edit",
    displayTitle: "Dynamic Report Edit",
    category: "Reporting",
  },
  DYNAMIC_REPORT_DELETE: {
    title: "dynamic-report-delete",
    displayTitle: "Dynamic Report Delete",
    category: "Reporting",
  },
  LICENSE_MANAGEMENT_VIEW: {
    title: "license-management-view",
    displayTitle: "License Management View",
    category: "License Management",
  },
  LICENSE_HISTORY_VIEW: {
    title: "license-history-view",
    displayTitle: "License History View",
    category: "License Management",
  },
  LICENSE_HISTORY_SYNC_BY_CSV: {
    title: "license-history-sync-by-csv",
    displayTitle: "License History Sync By CSV",
    category: "License History",
  },
  UPDATE_LICENSE_INFO: {
    title: "update-license-info",
    displayTitle: "Update License Info",
    category: "License Management",
  },
  LICENSE_CREATE: {
    title: "license-create",
    displayTitle: "License Create",
    category: "License Management",
  },
  LICENSE_EDIT: {
    title: "license-edit",
    displayTitle: "License Edit",
    category: "License Management",
  },
  BUDGET_CALCULATION_VIEW: {
    title: "budget-calculation-view",
    displayTitle: "Budget Calculation View",
    category: "Budget Calculation",
  },
  SAAS_TOOL_WISE_BUDGET_VIEW: {
    title: "saas-tool-wise-budget-view",
    displayTitle: "Saas Tool Wise Budget View",
    category: "Budget Calculation",
  },
  ORGANIZATION_WISE_BUDGET_VIEW: {
    title: "organization-wise-budget-view",
    displayTitle: "Organization Wise Budget View",
    category: "Budget Calculation",
  },
  USER_WISE_BUDGET_VIEW: {
    title: "user-wise-budget-view",
    displayTitle: "User Wise Budget View",
    category: "Budget Calculation",
  },
  EDIT_BUDGET: {
    title: "edit-budget",
    displayTitle: "Edit Budget",
    category: "Budget Calculation",
  },
  SAAS_TOOL_VIEW: {
    title: "saas-tool-view",
    displayTitle: "Saas Tool View",
    category: "Saas Tool",
  },
  SAAS_GROUP_VIEW: {
    title: "saas-group-view",
    displayTitle: "Saas Group View",
    category: "Saas Tool",
  },
  SAAS_PROJECT_VIEW: {
    title: "saas-project-view",
    displayTitle: "Saas Project View",
    category: "Saas Tool",
  },
  SAAS_USER_VIEW: {
    title: "saas-user-view",
    displayTitle: "Saas User View",
    category: "Saas Tool",
  },
  SAAS_INVITED_USER_VIEW: {
    title: "saas-invited-user-view",
    displayTitle: "Saas Invited User View",
    category: "Saas Tool",
  },
  SYNC_SAAS_USER: {
    title: "sync-saas-user",
    displayTitle: "Sync Saas User",
    category: "Saas Tool",
  },
  CLOUD_INFRA_VIEW: {
    title: "cloud-infra-view",
    displayTitle: "Cloud Infra View",
    category: "Cloud Infra",
  },
  CLOUD_USER_VIEW: {
    title: "cloud-user-view",
    displayTitle: "Cloud User View",
    category: "Cloud Infra",
  },
  CLOUD_INVITED_USER_VIEW: {
    title: "cloud-invited-user-view",
    displayTitle: "Cloud Invited User View",
    category: "Cloud Infra",
  },
  CLOUD_GROUP_VIEW: {
    title: "cloud-group-view",
    displayTitle: "Cloud Group View",
    category: "Cloud Infra",
  },
  CLOUD_PROJECT_VIEW: {
    title: "cloud-project-view",
    displayTitle: "Cloud Project View",
    category: "Cloud Infra",
  },
  FLOATING_LICENSE_VIEW: {
    title: "floating-license-view",
    displayTitle: "Floating License View",
    category: "Floating License",
  },
  INVENTORY_MANAGEMENT_VIEW: {
    title: "inventory-management-view",
    displayTitle: "Inventory Management View",
    category: "Inventory",
  },
  SUPPORT_TICKETS_VIEW: {
    title: "support-tickets-view",
    displayTitle: "Support Tickets View",
    category: "Support Tickets",
  },
  SUPPORT_TICKETS_REPORT_VIEW: {
    title: "support-tickets-report-view",
    displayTitle: "Support Tickets Report View",
    category: "Support Tickets",
  },
  SYNC_SUPPORT_TICKETS: {
    title: "sync-support-tickets",
    displayTitle: "Sync Support Tickets",
    category: "Support Tickets",
  },
  ORGANIZATION_VIEW: {
    title: "organization-view",
    displayTitle: "Organization View",
    category: "Organization",
  },
  ORGANIZATION_CREATE: {
    title: "organization-create",
    displayTitle: "Organization Create",
    category: "Organization",
  },
  ORGANIZATION_EDIT: {
    title: "organization-edit",
    displayTitle: "Organization Edit",
    category: "Organization",
  },
  ORGANIZATION_DELETE: {
    title: "organization-delete",
    displayTitle: "Organization Delete",
    category: "Organization",
  },
  USER_VIEW: {
    title: "user-view",
    displayTitle: "User View",
    category: "User Management",
  },
  USER_ROLE_EDIT: {
    title: "user-role-edit",
    displayTitle: "User Role Edit",
    category: "User Management",
  },
  USER_REGISTRATION: {
    title: "user-registration",
    displayTitle: "User Registration",
    category: "User Management",
  },
  USER_EDIT: {
    title: "user-edit",
    displayTitle: "User Edit",
    category: "User Management",
  },
  USER_DELETE: {
    title: "user-delete",
    displayTitle: "User Delete",
    category: "User Management",
  },
  USER_RESTORE: {
    title: "user-restore",
    displayTitle: "User Restore",
    category: "User Management",
  },
  USER_PROFILE: {
    title: "user-profile",
    displayTitle: "User Profile",
    category: "User Management",
  },
  PERMISSION_VIEW: {
    title: "permission-view",
    displayTitle: "Permission View",
    category: "Permission Management",
  },
  PERMISSION_CREATE: {
    title: "permission-create",
    displayTitle: "Permission Create",
    category: "Permission Management",
  },
  PERMISSION_EDIT: {
    title: "permission-edit",
    displayTitle: "Permission Edit",
    category: "Permission Management",
  },
  PERMISSION_DELETE: {
    title: "permission-delete",
    displayTitle: "Permission Delete",
    category: "Permission Management",
  },
  ROLE_VIEW: {
    title: "role-view",
    displayTitle: "Role View",
    category: "Role Management",
  },
  ROLE_CREATE: {
    title: "role-create",
    displayTitle: "Role Create",
    category: "Role Management",
  },
  ROLE_EDIT: {
    title: "role-edit",
    displayTitle: "Role Edit",
    category: "Role Management",
  },
  ROLE_DELETE: {
    title: "role-delete",
    displayTitle: "Role Delete",
    category: "Role Management",
  },

  PAYMENT_MANAGEMENT_VIEW: {
    title: "payment-management-view",
    displayTitle: "Payment Management View",
    category: "Payment Management",
  },
  PAYMENT_MANAGEMENT_CREATE: {
    title: "payment-management-create",
    displayTitle: "Payment Management Create",
    category: "Payment Management",
  },
  PAYMENT_MANAGEMENT_EDIT: {
    title: "payment-management-edit",
    displayTitle: "Payment Management Edit",
    category: "Payment Management",
  },
  PAYMENT_MANAGEMENT_DELETE: {
    title: "payment-management-delete",
    displayTitle: "Payment Management Delete",
    category: "Payment Management",
  },
  APPROVER_VIEW: {
    title: "approver-view",
    displayTitle: "Approver View",
    category: "Request Management",
  },
  APPROVER_CREATE: {
    title: "approver-create",
    displayTitle: "Approver Create",
    category: "Request Management",
  },
  APPROVER_EDIT: {
    title: "approver-edit",
    displayTitle: "Approver Edit",
    category: "Request Management",
  },
  APPROVER_DELETE: {
    title: "approver-delete",
    displayTitle: "Approver Delete",
    category: "Request Management",
  },
  REQUEST_MANAGEMENT_VIEW: {
    title: "request-view",
    displayTitle: "Request View",
    category: "Request Management",
  },
  REQUEST_MANAGEMENT_CREATE: {
    title: "request-create",
    displayTitle: "Create Request",
    category: "Request Management",
  },
  REQUEST_MANAGEMENT_USER_PROFILE_UPDATE_REQUEST: {
    title: "user-profile-update-request",
    displayTitle: "User Profile Update Request",
    category: "Request Management",
  },
  REQUEST_MANAGEMENT_APPROVE: {
    title: "request-approve",
    displayTitle: "Request Approve",
    category: "Request Management",
  },
  SECURITY_TOOL_USER_VIEW: {
    title: "security-tool-user-view",
    displayTitle: "Security Tool User View",
    category: "Security Tool Management",
  },
  SECURITY_TOOL_INVITED_USER_VIEW: {
    title: "security-tool-invited-user-view",
    displayTitle: "Security Tool Invited User View",
    category: "Security Tool Management",
  },
  SECURITY_TOOL_GROUP_VIEW: {
    title: "security-tool-group-view",
    displayTitle: "Security Tool Group View",
    category: "Security Tool Management",
  },
  APPROVAL_MANAGEMENT_VIEW: {
    title: "approval-management-view",
    displayTitle: "Approval Management View",
    category: "Approval Management",
  },
  APPROVAL_MANAGEMENT_PENDING_VIEW: {
    title: "approval-management-pending-view",
    displayTitle: "Approval Management Pending View",
    category: "Approval Management",
  },
  APPROVAL_MANAGEMENT_APPROVED_VIEW: {
    title: "approval-management-approved-view",
    displayTitle: "Approval Management Approved View",
    category: "Approval Management",
  },
  NOTIFICATION_ALERTS_VIEW: {
    title: "notification-alerts-view",
    displayTitle: "Notification Alerts View",
    category: "Notification Alerts",
  },
  DASHBOARD_ADMIN_VIEW: {
    title: "dashboard-admin-view",
    displayTitle: "Dashboard Admin View",
    category: "Dashboard",
  },
  CREDENTIALS_MANAGEMENT_VIEW: {
    title: "credentials-management-view",
    displayTitle: "Credentials Management View",
    category: "Credentials Management",
  },
  CREDENTIALS_MANAGEMENT_ADMIN_VIEW: {
    title: "credentials-management-admin-view",
    displayTitle: "Credentials Management Admin View",
    category: "Credentials Management",
  },
  CREDENTIALS_MANAGEMENT_CREATE: {
    title: "credentials-management-create",
    displayTitle: "Credentials Management Create",
    category: "Credentials Management",
  },
  CREDENTIALS_MANAGEMENT_DELETE: {
    title: "credentials-management-delete",
    displayTitle: "Credentials Management Delete",
    category: "Credentials Management",
  },
  SLEET_PROJECT_CREATE: {
    title: "sleet-project-create",
    displayTitle: "Sleet Project Create",
    category: "Credentials Management",
  },
  SLEET_PROJECT_DELETE: {
    title: "sleet-project-delete",
    displayTitle: "Sleet Project Delete",
    category: "Credentials Management",
  },
};

export const SUPPORT_TICKET_STATUS = [
  { label: "In Review", value: "In Review" },
  { label: "Approved", value: "Approved" },
  { label: "Rejected", value: "Rejected" },
  { label: "In Progress", value: "In Progress" },
  {
    label: "Waiting for Customer Response",
    value: "Waiting for Customer Response",
  },
  { label: "Fixed", value: "Fixed" },
  { label: "Closed", value: "Closed" },
];

export const TICKETS_STATUS_OPTIONS = (status: string) => {
  if (status === "Approved")
    return [
      { label: "In Progress", value: "In Progress" },
      { label: "Canceled", value: "Canceled" },
    ];
  else if (status === "In Progress")
    return [
      {
        label: "Waiting for Customer Response",
        value: "Waiting for Customer Response",
      },
    ];
  else if (status === "Waiting for Customer Response")
    return [
      { label: "In Progress", value: "In Progress" },
      { label: "Fixed", value: "Fixed" },
    ];
  else if (status === "Fixed") return [{ label: "Closed", value: "Closed" }];
  else return [];
};
export const USER_REQUEST_INFO = {
  DEFAULT: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Create Request:</h2>
        <p>The type of request which is intended to be created can be picked from the <strong>"Request Type"</strong> field.</p>
        <p>Based on the Request Type, the sub type will change.</p>
        <p>Based on the selection of the <strong>"Sub Type"</strong>, the page/form will be updated accordingly.</p>
        <p>The exact type of request is broken into subcategories which can be selected from the <strong>"Sub Type"</strong>.</p>
        <p>Multiple users can be selected as <strong>Watchers</strong>, who will receive notifications about any updates to the request.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,

  USER_ONBOARDING: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>User Onboarding:</h2>
        <p>This page is used for onboarding or adding new users.</p>
        <p>Please insert the required details in the form.</p>
        <p><strong>"Okta"</strong> and <strong>"UR&AM Tool"</strong> are the SaaS tools selected by default for Mitutoyo users.</p>
        <p>For other users, the <strong>"Okta"</strong> tool is selected by default.</p>
        <p>Click on the <strong>"Add More Tool"</strong> button to add one or more SaaS tools.</p>
        <p>When adding a tool, the delete icon can be clicked to remove the entry of the SaaS tool.</p>
        <p>Click on the <strong>"Add Another User"</strong> button to add more users.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the <strong>"Submit"</strong> button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,

  USER_OFFBOARDING: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>User Offboarding:</h2>
        <p>This page is used for offboarding or removing existing users.</p>
        <p>Please select the user or fill in the name in the <strong>"Select user"</strong> field to offboard.</p>
        <p>The <strong>"Approver's Name"</strong> is automatically selected, which is the name of the personal in charge of the user.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,

  ASSIGN_LICENSE: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Assign License:</h2>
        <p>This page is used to assign a new license to an existing user.</p>
        <p>The tools available are listed in the <strong>"Available Tools"</strong> section, referred by their icons. These icons can be clicked to get more information on the tool's users or groups.</p>
        <p>The tools assigned to a user are shown by the icons in the <strong>"Assigned Tools"</strong> section. These icons can be clicked to get more information on data for the user in the tool.</p>
        <p>Click on the <strong>"Add SaaS Tool"</strong> button to add more than one SaaS tool.</p>
        <p>When adding a tool, the delete icon can be clicked to remove the entry of the SaaS tool.</p>
        <p>Please select the tool for assigning a new license in the <strong>"Select Tool"</strong> option and fill in the further required details.</p>
        <p>Only the tools not assigned to the user are available to be selected.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  REMOVE_LICENSE: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Remove License:</h2>
        <p>This page is used to remove a license from an existing user.</p>
        <p>Please select or fill in the name of the user in the <strong>"Select User"</strong> part.</p>
        <p>The tools assigned to a user are shown by the icons in the <strong>"Assigned Tools"</strong> section. These icons can be clicked to get more information on data for the user in the tool.</p>
        <p>Click on the <strong>"Add Tool To List"</strong> button to add one or more SaaS tools.</p>
        <p>Type the SaaS tool name or select it from the <strong>"Select SaaS Tool"</strong> option.</p>
        <p>Only the tools assigned to the user are available to be selected.</p>
        <p>When adding a tool, the delete icon can be clicked to remove the entry of the SaaS tool.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  CREATE_PROJECT: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Project Creation:</h2>
        <p>This page is used to create a new project within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>

        <h3>YouTrack Project Templates</h3>
        <p><b>Default:</b> YouTrack’s standard issue tracking solution with default issue fields and workflows.</p>
        <p><b>Helpdesk:</b>  Creates a project that is specifically designed for handling customer support requests and other types of feedback from external users.</p>
        <p><b>Scrum:</b> Creates a project that is pre-configured to follow the Scrum development methodology.</p>
        <p><b>Kanban:</b> Creates a project that is pre-configured to follow Kanban or any other lean development methodology.</p>
        <p><b>Scrum (推奨：製品開発ガイドラインに対応):</b> This is the recommended Scrum template. This template complies with product development guidelines.</p>
        <p><b>Waterfall (推奨：製品開発ガイドラインに対応):</b> This is the recommended Waterfall template. This template complies with product development guidelines.</p>

    </div>`,
  CREATE_GROUP: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Group Creation:</h2>
        <p>This page is used to create a new group within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  CREATE_SPACE: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Space Creation:</h2>
        <p>This page is used to create a new space within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
        <h3>Confluence Space Templates</h3>
        <p><b>Collaboration:</b> This template is used to create a space for team collaboration.</p>
        <p><b>Knowledge Base:</b> This template is used to create a space for storing and sharing knowledge within the organization.</p>
      </div>`,
  CREATE_TEAM: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Team Creation:</h2>
        <p>This page is used to create a new team within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  CREATE_DASHBOARD: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Dashboard Creation:</h2>
        <p>This page is used to create a new dashboard within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  MODIFY_PROJECT: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Project Modification:</h2>
        <p>This page is used to modify an existing project within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  MODIFY_GROUP: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Group Modification:</h2>
        <p>This page is used to modify an existing group within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  MODIFY_SPACE: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Space Modification:</h2>
        <p>This page is used to modify an existing space within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  MODIFY_TEAM: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Team Modification:</h2>
        <p>This page is used to modify an existing team within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  MODIFY_DASHBOARD: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Dashboard Modification:</h2>
        <p>This page is used to modify an existing dashboard within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
   </div>`,
  DELETE_PROJECT: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Project Deletion:</h2>
        <p>This page is used to delete an existing project within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  DELETE_GROUP: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Group Deletion:</h2>
        <p>This page is used to delete an existing group within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  DELETE_SPACE: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Space Deletion:</h2>
        <p>This page is used to delete an existing space within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  DELETE_TEAM: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Team Deletion:</h2>
        <p>This page is used to delete an existing team within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  DELETE_DASHBOARD: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Dashboard Deletion:</h2>
        <p>This page is used to delete an existing dashboard within a designated SaaS tool.</p>
        <p>Select the tool name and enter the name where the user is assigned.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  ASSIGN_PERMISSION: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Assign Permission:</h2>
        <p>This page is used to assign new permission to an existing user.</p>
        <p>The tools available are listed in the <strong>"All SaaS Tools"</strong> section, referred to by their icons. These icons can be clicked to get more information on the tool's users or groups.</p>
        <p>Please select or fill in the name of the user in the <strong>"Select an Option"</strong> part.</p>
        <p>The tools assigned to a user are shown by the icons in the <strong>"Assigned Tools"</strong> section. These icons can be clicked to get more information on data for the user in the tool.</p>
        <p>Please select the tool for assigning new permission in the <strong>"Select SaaS Tool"</strong> option and fill in further details as required.</p>
        <p>Only the tools assigned to the user are available to be selected.</p>
        <p>Click on the <strong>"Add SaaS Tool"</strong> button to add more than one SaaS tool.</p>
        <p>When adding a tool, the delete icon can be clicked to remove the entry of the SaaS tool.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  MODIFY_PERMISSION: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Modify Permission:</h2>
        <p>This page is used to modify existing permission for an existing user.</p>
        <p>The tools available are listed in the <strong>"All SaaS Tools"</strong> section, referred to by their icons. These icons can be clicked to get more information on the tool's users or groups.</p>
        <p>Please select or fill in the name of the user in the <strong>"Select an Option"</strong> part.</p>
        <p>The tools assigned to a user are shown by the icons in the <strong>"Assigned Tools"</strong> section. These icons can be clicked to get more information on data for the user in the tool.</p>
        <p>Please select the tool for assigning the modified permission in the <strong>"Assign New Item"</strong> section.</p>
        <p>Only the tools assigned to the user are available to be selected.</p>
        <p>Click on the <strong>"Add SaaS Tool"</strong> button to add more than one SaaS tool.</p>
        <p>When adding a tool, the delete icon can be clicked to remove the entry of the SaaS tool.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  REMOVE_PERMISSION: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Remove Permission:</h2>
        <p>This page is used to remove existing permission for an existing user.</p>
        <p>The tools available are listed in the <strong>"All SaaS Tools"</strong> section, referred to by their icons. These icons can be clicked to get more information on the tool's users or groups.</p>
        <p>Please select or fill in the name of the user in the <strong>"Select an Option"</strong> part.</p>
        <p>The tools assigned to a user are shown by the icons in the <strong>"Assigned SaaS Tools"</strong> section. These icons can be clicked to get more information on data for the user in the tool.</p>
        <p>Please select the tool for removing the permission in the <strong>"Assign New Item"</strong> section.</p>
        <p>Only the tools assigned to the user are available to be selected.</p>
        <p>Click on the <strong>"Add SaaS Tool"</strong> button to add more than one SaaS tool.</p>
        <p>When adding a tool, the delete icon can be clicked to remove the entry of the SaaS tool.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  CONFIGURATION: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Configuration:</h2>
        <p>This page is for creating a request related to any configuration issue connected to a SaaS tool.</p>
        <p>Please select the name of the SaaS tool in the <strong>"Select SaaS Tool"</strong> option.</p>
        <p>Write the issue summary in the <strong>"Issue Summary"</strong> field.</p>
        <p>Please enter the description of the issue in the <strong>"Issue Description"</strong> field.</p>
        <p>Please enter any issue-related attachments in the <strong>Attachment</strong> section. Note that a maximum of 5 attachments can be selected.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
  CREATE_CREDENTIALS_FOR_SLEET: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Create Credentials for Sleet:</h2>
        <p>This page is used to create credentials for Sleet.</p>
        <p>Please select the User in the <strong>"Select a user"</strong> option.</p>
        <p>Please select the Sleet project in the <strong>"Select Sleet Project"</strong> option.</p>
        <p><strong>Email</strong> will be automatically populated based on the selected user.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
    DELETE_CREDENTIALS_FOR_SLEET: `<div style="display:flex; flex-direction:column; row-gap:20px"></div>
        <h2>Delete Credentials for Sleet:</h2>
        <p>This page is used to delete credentials for Sleet.</p>
        <p>Please select the User in the <strong>"Select a user"</strong> option.</p>
        <p>Please select the Sleet project in the <strong>"Select Sleet Project"</strong> option.</p>
        <p><strong>Email</strong> will be automatically populated based on the selected user.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
    USER_PROFILE_UPDATE: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>User Profile Update:</h2>
        <p>This page is used to update the user's okta profile.</p>
        <p>Please select the User in the <strong>"Select a user"</strong> option.</p>
        <p>All Related fields will be automatically populated based on the selected user.</p>
        <p>Update the fields you want to change.</p>
        <p>Fill the <strong>Required</strong> fields.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
    OTHERS: `<div style="display:flex; flex-direction:column; row-gap:20px">
        <h2>Others:</h2>
        <p>This page is used for any other requests that do not fall under the predefined categories.</p>
        <p>Write the issue summary in the <strong>"Issue Summary"</strong> field.</p>
        <p>Please enter the description of the issue in the <strong>"Issue Description"</strong> field.</p>
        <p>Please enter any issue-related attachments in the <strong>Attachment</strong> section. Note that a maximum of 5 attachments can be selected.</p>
        <p>Write notes or comments in the <strong>"Notes"</strong> field and submit the request by clicking the submit button, or cancel the request by clicking on the <strong>"Cancel"</strong> button.</p>
    </div>`,
};
